import { type FC, useState } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import AidRelatedCard from "../../components/popups/aid-related-card/AidRelatedCard";
import OrganizationRequest, {
  type OrganizationRequestProps,
} from "./OrganizationRequest";
import { useRequest } from "../../contexts/RequestProvider";
import { type Association, type Opportunity } from "@entities";
import { associationRepo } from "@repositories";

export const OrganizationRequestFullContainer: FC<OrganizationRequestProps> = ({
  selectedList,
  eventData,
  isEventCard = false,
  onSaveSuccess,
}) => {
  const { setCurrentEvent: setRequestDetails } = useRequest();
  const [isAddAidRelated, setIsAddAidRelated] = useState<boolean>(false);
  const location = useLocation();
  const locationState = location.state as
    | Opportunity
    | { selectedList?: string; eventData?: Opportunity; }
    | undefined;
  const stateEventData =
    locationState && "id" in locationState
      ? (locationState as Opportunity)
      : locationState?.eventData;
  const effectiveSelectedList =
    selectedList ?? (locationState as { selectedList?: string; }).selectedList;
  const effectiveEventData = eventData ?? stateEventData;
  const isEditOrDuplicate =
    effectiveSelectedList === "edit" ||
    effectiveSelectedList === "duplicate";
  const isEdit = effectiveSelectedList === "edit" || !!effectiveEventData?.id;

  return (
    <Box
      className="organization-request-full-page"
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        width: "100%",
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <OrganizationRequest
        selectedList={effectiveSelectedList}
        isEventCard={isEventCard}
        showExtendedLayout={!isEventCard || isEditOrDuplicate}
        isStandalonePage={!isEventCard}
        eventData={effectiveEventData}
        isEdit={isEdit}
        setIsAddAidRelated={setIsAddAidRelated}
        onSaveSuccess={onSaveSuccess}
      />
      {isAddAidRelated && (
        <Box
          sx={{
            position: "absolute",
            width: 0,
            height: 0,
          }}
        >
          <AidRelatedCard
            isAdd={isAddAidRelated}
            defaultValues={undefined}
            onSave={async (association: Association) => {
              const asso = await associationRepo.findId(association.id, {
                include: {
                  user: true,
                },
              });
              setRequestDetails((prev) => ({
                ...prev,
                associationRequested: asso ?? undefined,
                associationRequestedId: asso?.id ?? null,
              }));
            }}
            onClose={() => {
              setIsAddAidRelated(false);
            }}
          />
        </Box>
      )}
    </Box>
  );
};
